/* eslint-disable */
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
 */

import 'es6-promise/auto';

(function () {
  'use strict';
  // global for (1) existence means `WebComponentsReady` will fire,
  // (2) WebComponents.ready == true means event has fired.
  window.WebComponents = window.WebComponents || {};
  var name = 'webcomponents-loader';
  var scripts = {
    'webcomponents-hi-ce': function () {
      import('@webcomponents/webcomponentsjs/webcomponents-hi-ce');
    },
    'webcomponents-hi-sd-ce': function () {
      import('@webcomponents/webcomponentsjs/webcomponents-hi-sd-ce');
    },
    'webcomponents-hi-sd': function () {
      import('@webcomponents/webcomponentsjs/webcomponents-hi-sd');
    },
    'webcomponents-hi': function () {
      import('@webcomponents/webcomponentsjs/webcomponents-hi');
    },
    'webcomponents-lite': function () {
      import('@webcomponents/webcomponentsjs/webcomponents-lite');
    },
    'webcomponents-sd-ce': function () {
      import('@webcomponents/webcomponentsjs/webcomponents-sd-ce');
    },
  }
  // Feature detect which polyfill needs to be imported.
  var polyfills = [];
  if (!('import' in document.createElement('link'))) {
    polyfills.push('hi');
  }
  if (!('attachShadow' in Element.prototype && 'getRootNode' in Element.prototype) ||
    (window.ShadyDOM && window.ShadyDOM.force)) {
    polyfills.push('sd');
  }
  if (!window.customElements || window.customElements.forcePolyfill) {
    polyfills.push('ce');
  }
  // NOTE: any browser that does not have template or ES6 features
  // must load the full suite (called `lite` for legacy reasons) of polyfills.
  if (!('content' in document.createElement('template')) || !window.Promise || !Array.from ||
    // Edge has broken fragment cloning which means you cannot clone template.content
    !(document.createDocumentFragment().cloneNode() instanceof DocumentFragment)) {
    polyfills = ['lite'];
  }

  if (polyfills.length) {
    var replacement = 'webcomponents-' + polyfills.join('-');
    if (typeof scripts[replacement] === 'function') {
      scripts[replacement]();
    }
  } else {
    // Ensure `WebComponentsReady` is fired also when there are no polyfills loaded.
    // however, we have to wait for the document to be in 'interactive' state,
    // otherwise a rAF may fire before scripts in <body>

    var fire = function () {
      requestAnimationFrame(function () {
        window.WebComponents.ready = true;
        document.dispatchEvent(new CustomEvent('WebComponentsReady', { bubbles: true }));
      });
    };

    if (document.readyState !== 'loading') {
      fire();
    } else {
      document.addEventListener('readystatechange', function wait() {
        fire();
        document.removeEventListener('readystatechange', wait);
      });
    }
  }
})();



// WEBPACK FOOTER //
// ./js/webcomponents-loader/index.js